import { apiGet, apiPost, apiPatch, apiDelete } from './api';

export interface Campaign {
  id: string;
  tenantId: string;
  name: string;
  product: string | null;
  tone: 'professional' | 'friendly' | 'direct';
  goal: string | null;
  context: string | null;
  createdAt: string;
  updatedAt: string;
  leadCount: number;
  emailsGenerated: number;
}

export interface CampaignCreateInput {
  name: string;
  product?: string;
  tone?: string;
  goal?: string;
  context?: string;
}

export async function getCampaigns(): Promise<Campaign[]> {
  return apiGet<Campaign[]>('/campaigns');
}

export async function getCampaign(id: string): Promise<Campaign> {
  return apiGet<Campaign>(`/campaigns/${id}`);
}

export async function createCampaign(data: CampaignCreateInput): Promise<Campaign> {
  return apiPost<Campaign>('/campaigns', data);
}

export async function updateCampaign(id: string, data: Partial<CampaignCreateInput>): Promise<Campaign> {
  return apiPatch<Campaign>(`/campaigns/${id}`, data);
}

export async function deleteCampaign(id: string): Promise<void> {
  await apiDelete(`/campaigns/${id}`);
}

export async function addLeadGroupsToCampaign(campaignId: string, leadGroupIds: string[]): Promise<{ added: number }> {
  return apiPost<{ added: number }>(`/campaigns/${campaignId}/lead-groups`, { leadGroupIds });
}

export async function removeLeadGroupsFromCampaign(campaignId: string, leadGroupIds: string[]): Promise<{ removed: number }> {
  return apiDelete<{ removed: number }>(`/campaigns/${campaignId}/lead-groups`, { leadGroupIds });
}

export async function getCampaignLeadGroups(campaignId: string): Promise<unknown[]> {
  return apiGet<unknown[]>(`/campaigns/${campaignId}/lead-groups`);
}

export async function getCampaignLeads(campaignId: string): Promise<unknown[]> {
  return apiGet<unknown[]>(`/campaigns/${campaignId}/leads`);
}
